export default {"src":"/_next/static/media/imageShadowMedium.fffb9bd8.svg","height":6,"width":138};